import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutBanner from './components/AboutBanner';
import CompanyIntro from './components/CompanyIntro';
import CoreValues from './components/CoreValues';
import CompanyHistory from './components/CompanyHistory';
import AgencyBrands from './components/AgencyBrands';

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <AboutBanner />
        <CompanyIntro />
        <CoreValues />
        <CompanyHistory />
        <AgencyBrands />
      </main>
      <Footer />
    </div>
  );
}
